import { useState, useEffect, useRef } from "preact/hooks";

import CompanySearch from "./CompanySearch";
import Dropdown from "../../components/Dropdown";

import { useAutoCompleteState } from "../../context";

const SearchInputIndex = ({ inputClass, dropdownClass }) => {
  const containerRef = useRef(null);

  const [showList, setShowList] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [triggerSearch, setTriggerSearch] = useState(true);

  const [{ suggestions }, { getCompanies }] = useAutoCompleteState();

  const handleSearch = name => {
    setSearchTerm(name);
  };

  useEffect(() => {
    if (searchTerm && searchTerm.length >= 3 && triggerSearch) {
      getCompanies(searchTerm);
    }
    setTriggerSearch(true);
  }, [searchTerm]);

  const handleDocumentClick = e => {
    const container = containerRef.current;
    const { target } = e;

    if (!container.contains(target) && container !== target) {
      setShowList(false);
    }
  };

  const handleSelect = company => {
    setTriggerSearch(false);
    setSearchTerm(company.name);
    setShowList(false);
  };

  useEffect(() => {
    document.addEventListener("click", handleDocumentClick, true);
    return () => {
      document.removeEventListener("click", handleDocumentClick, true);
    };
  }, []);

  return (
    <div style={{ position: "relative" }} ref={containerRef}>
      <CompanySearch
        onChange={handleSearch}
        onFocus={() => setShowList(true)}
        searchTerm={searchTerm}
        className={inputClass}
      />
      {showList && (
        <Dropdown
          onSelect={handleSelect}
          suggestions={suggestions}
          className={dropdownClass}
        />
      )}
    </div>
  );
};

export default SearchInputIndex;



// WEBPACK FOOTER //
// ./AutoComplete/containers/CompanySearch/index.js